export default __webpack_public_path__ + "static/media/sub-admin-white.e9ef95c2.svg";